var map = {
	"./bg-login-page-dark.svg": 293,
	"./bg-login-page.svg": 6090,
	"./data-reports.svg": 8976,
	"./error-illustration.svg": 3801,
	"./food-beverage-1.jpg": 2579,
	"./food-beverage-10.jpg": 3834,
	"./food-beverage-11.jpg": 9482,
	"./food-beverage-12.jpg": 3851,
	"./food-beverage-13.jpg": 647,
	"./food-beverage-14.jpg": 2543,
	"./food-beverage-15.jpg": 3604,
	"./food-beverage-16.jpg": 1461,
	"./food-beverage-17.jpg": 385,
	"./food-beverage-18.jpg": 880,
	"./food-beverage-19.jpg": 6173,
	"./food-beverage-2.jpg": 9832,
	"./food-beverage-3.jpg": 1886,
	"./food-beverage-4.jpg": 8177,
	"./food-beverage-5.jpg": 6239,
	"./food-beverage-6.jpg": 8266,
	"./food-beverage-7.jpg": 2397,
	"./food-beverage-8.jpg": 3085,
	"./food-beverage-9.jpg": 1056,
	"./illustration.svg": 6617,
	"./logo.svg": 2835,
	"./map-marker-region.png": 9090,
	"./map-marker.png": 1019,
	"./phone-illustration.svg": 6258,
	"./placeholders/200x200.jpg": 3883,
	"./placeholders/800x800.jpg": 6285,
	"./preview-1.jpg": 4216,
	"./preview-10.jpg": 7725,
	"./preview-11.jpg": 9102,
	"./preview-12.jpg": 6155,
	"./preview-13.jpg": 6345,
	"./preview-14.jpg": 2424,
	"./preview-15.jpg": 6020,
	"./preview-16.jpg": 3781,
	"./preview-17.jpg": 1857,
	"./preview-18.jpg": 2131,
	"./preview-19.jpg": 3044,
	"./preview-2.jpg": 8297,
	"./preview-3.jpg": 4013,
	"./preview-4.jpg": 8582,
	"./preview-5.jpg": 6370,
	"./preview-6.jpg": 6240,
	"./preview-7.jpg": 2118,
	"./preview-8.jpg": 1463,
	"./preview-9.jpg": 9556,
	"./profile-1.jpg": 2563,
	"./profile-10.jpg": 5005,
	"./profile-11.jpg": 4539,
	"./profile-12.jpg": 289,
	"./profile-13.jpg": 2102,
	"./profile-14.jpg": 8252,
	"./profile-15.jpg": 7621,
	"./profile-16.jpg": 2417,
	"./profile-17.jpg": 7105,
	"./profile-18.jpg": 4147,
	"./profile-19.jpg": 4570,
	"./profile-2.jpg": 717,
	"./profile-3.jpg": 4235,
	"./profile-4.jpg": 2865,
	"./profile-5.jpg": 6025,
	"./profile-6.jpg": 8689,
	"./profile-7.jpg": 9326,
	"./profile-8.jpg": 3623,
	"./profile-9.jpg": 7119,
	"./reports.svg": 5036,
	"./woman-illustration.svg": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;